var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverFlowLivePad = function SvgOverFlowLivePad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9867"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9854",
    transform: "translate(-297 -634)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 61",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(297 634)",
    fill: "#f9db41"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1136",
    d: "M33.033 11.742v14.307l-6.983 6.983H11.742a.776.776 0 0 1-.774-.774V11.742a.776.776 0 0 1 .774-.774h20.516a.776.776 0 0 1 .775.774Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1137",
    d: "M26.049 34H11.742A1.745 1.745 0 0 1 10 32.258V11.742A1.745 1.745 0 0 1 11.742 10h20.516A1.745 1.745 0 0 1 34 11.742v14.307a.97.97 0 0 1-.283.685l-6.983 6.983a.97.97 0 0 1-.685.283Zm-14.114-1.935h13.711l6.418-6.418V11.935H11.935Zm21.1-6.015Z",
    fill: "#76777a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 67",
    fill: "#ffc56d",
    d: "M10.968 10.968h22.065v5.253H10.968z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1138",
    d: "M33.032 17.188H10.968a.968.968 0 0 1-.968-.967v-4.479A1.745 1.745 0 0 1 11.742 10h20.516A1.745 1.745 0 0 1 34 11.742v4.479a.968.968 0 0 1-.968.967Zm-21.097-1.935h20.13v-3.318h-20.13Z",
    fill: "#ff9e18"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1139",
    d: "M10.968 17.188a.968.968 0 0 1-.968-.967v-4.479A1.745 1.745 0 0 1 11.742 10h7.44a.968.968 0 1 1 0 1.935h-7.247v4.286a.968.968 0 0 1-.967.967Z",
    fill: "#fd4a5c"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9773",
    fill: "#fd4a5c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1140",
    d: "M27.485 22.936H16.517a.968.968 0 1 1 0-1.935h10.972a.968.968 0 1 1 0 1.935Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1141",
    d: "M27.485 27.581H16.517a.968.968 0 1 1 0-1.935h10.972a.968.968 0 1 1 0 1.935Z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1142",
    d: "M26.049 33.032v-6.209a.776.776 0 0 1 .774-.774h6.209Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1143",
    d: "M26.049 34a.966.966 0 0 1-.968-.968v-6.211a1.745 1.745 0 0 1 1.74-1.74h6.209a.966.966 0 0 1 .685 1.649l-6.981 6.991a.967.967 0 0 1-.685.279Zm.972-6.979v3.677l3.673-3.677Z",
    fill: "#76777a"
  }))));
};
export default SvgOverFlowLivePad;